import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import "@/components/SessionTimeout/SessionTimeoutModal.css";

import IdleTimer from "@/components/SessionTimeout/IdleTimer";
import SessionTimeoutCountdown from "@/components/SessionTimeout/SessionTimeoutCountdown";
import { SESSION_TIMEOUT, TIMEOUT_PROMPT } from "@/constants/session_timeout";

export default function SessionTimeoutModal() {
  const idleTimeout = SESSION_TIMEOUT * 1000;
  const promptBeforeIdle = TIMEOUT_PROMPT * 1000;

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    idleTimer.reset();
    setOpen(false);
  };
  const handleIdle = () => setOpen(true);

  const { idleTimer, getRemainingTime } = IdleTimer({
    onIdle: handleIdle,
    idleTimeout,
    promptBeforeIdle,
  });

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="session-timeout-inner-modal">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            session expiration warning!
          </Typography>
          {open && (
            <SessionTimeoutCountdown
              idleTimer={idleTimer}
              getRemainingTime={getRemainingTime}
              promptBeforeIdle={promptBeforeIdle}
            />
          )}
          <Button
            className="session-timeout-button siteBlueOutlined"
            onClick={handleClose}
          >
            continue
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
